<template>
  <div>
    <h2 class="ViewHeading">Initialise Devices</h2>

    <!-- {{ this.newOrderDeviceInfo }} -->

    <b-card>
      <b-row>
        <b-col cols="3"> Company </b-col>
        <b-col cols="3">
          <b-form-select
            v-model="SelectedCompany"
            :options="companyArray"
            class="mb-3"
          >
          </b-form-select>
        </b-col>
        <b-col cols="3"> </b-col> <b-col cols="3"> </b-col>
      </b-row>

      <!-- <b-button v-on:click="addNewRowVersion(DeviceType, NoOfDevices)">
        Add New Device
      </b-button> -->
      <!-- <b-button v-on:click="removeRow('')">
        Remove Device Type
      </b-button> -->

      <b-row>
        <b-col cols="3"> Device Type </b-col>
        <b-col cols="3"
          ><b-form-select
            v-model="DeviceType"
            :options="DeviceTypeList"
            class="mb-3"
            Info
          >
          </b-form-select>
        </b-col>
        <b-col cols="3"> Amount of Devices </b-col>
        <b-col cols="3">
          <b-form-input
            type="text"
            placeholder="No of Devices to add to Device Type"
            v-model="NoOfDevices"
            required
            min="0"
            max="9999"
            step="0.1"
            onkeydown="return event.keyCode !== 69"
            @focus="modal = false"
          />
        </b-col>
      </b-row>
      <b-button v-on:click="addNewRowVersion(DeviceType, NoOfDevices)">
        Add New Device
      </b-button>
      <!-- Give them ability to make more rows -->
      <!-- {{ this.newOrderDeviceInfo }} -->
      <section v-for="(id, idx1) in this.newOrderDeviceInfo[0].C1" :key="idx1">
        <!-- {{ id }} -->
        <hr />
        C-1 Device No {{ idx1 + 1 }}
        <b-row>
          <b-col cols="11"> </b-col>
          <b-col cols="1">
            <BIconX
              font-scale="1.5"
              variant="danger"
              v-if="
                id.Info.DeviceID == '' ||
                  id.Info.MacAddress == '' ||
                  id.Info.BoardVersion == '' ||
                  id.Info.LanguageVersion == '' ||
                  id.Info.OSversion == ''
              "
            >
            </BIconX>
            <BIconCheck
              font-scale="1.5"
              variant="success"
              v-if="
                (id.Info.DeviceID != '') &
                  (id.Info.MacAddress != '') &
                  (id.Info.BoardVersion != '') &
                  (id.Info.LanguageVersion != '') &
                  (id.Info.OSversion != '')
              "
            >
            </BIconCheck>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Device ID </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="DeviceID"
              v-model="id.Info.DeviceID"
              required
              min="0"
              max="9999"
              step="0.1"
              onkeydown="return event.keyCode !== 69"
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Double Pipe </b-col>
          <b-col cols="3">
            <b-form-checkbox
              :id="'checkbox-1' + idx1"
              v-model="id.Info.Double"
              :name="'checkbox-1' + idx1"
              value="TRUE"
              unchecked-value="FALSE"
            >
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Outdoor </b-col>
          <b-col cols="3">
            <b-form-checkbox
              :id="'checkbox-1-Outdoor' + idx1"
              v-model="id.Info.Outdoor"
              :name="'checkbox-1-Outdoor' + idx1"
              value="TRUE"
              unchecked-value="FALSE"
            >
            </b-form-checkbox>
          </b-col>
          <b-col cols="3"> Mac Address </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Mac Address"
              v-model="id.Info.MacAddress"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Board Version </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Board Version"
              v-model="id.Info.BoardVersion"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Language Version </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Language Version"
              v-model="id.Info.LanguageVersion"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> OS Version </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="OS Version"
              v-model="id.Info.OSversion"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Kernel </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Kernel Version"
              v-model="id.Info.Kernel"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
      </section>
      <section v-for="(id, idx2) in this.newOrderDeviceInfo[1].O1" :key="idx2">
        <hr />
        O-1 Device No {{ idx2 + 1 }}
        <b-row>
          <b-col cols="3"> Device ID </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="DeviceID"
              v-model="id.Info.DeviceID"
              required
              min="0"
              max="9999"
              step="0.1"
              onkeydown="return event.keyCode !== 69"
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Device Name </b-col>
          <b-col cols="3">
            <b-form-input
              :id="'checkbox-1' + idx2"
              v-model="id.Info.DeviceName"
              :name="'checkbox-1' + idx2"
            >
            </b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Hardware Version </b-col>
          <b-col cols="3">
            <b-form-input
              :id="'checkbox-1-Outdoor' + idx2"
              v-model="id.Info.HardwareVersion"
              :name="'checkbox-1-Outdoor' + idx2"
            >
            </b-form-input>
          </b-col>
          <b-col cols="3"> Dev EUI </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Dev EUI"
              v-model="id.Info.DevEUI"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> App EUI </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="App EUI"
              v-model="id.Info.AppEUI"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> App Key </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="App Key"
              v-model="id.Info.AppKey"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Network Server Address </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Network Server Address"
              v-model="id.Info.NetworkServerAddress"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
      </section>
      <section v-for="(id, idx3) in this.newOrderDeviceInfo[3].HUB" :key="idx3">
        <hr />
        Network Gateway No {{ idx3 + 1 }}

        <b-row>
          <b-col cols="3"> Gateway Name </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway Name"
              v-model="id.Info.GatewayName"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Gateway ID </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway ID"
              v-model="id.Info.GatewayID"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Gateway EUI </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway EUI"
              v-model="id.Info.GatewayEUI"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Gateway Username </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway Username"
              v-model="id.Info.GatewayUsername"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Gateway Password </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway Password"
              v-model="id.Info.GatewayPassword"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Sim Card Number </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Sim Card Number"
              v-model="id.Info.SimCardNumber"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Firmware Version </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Firmware Version"
              v-model="id.Info.FirmwareVersion"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> WAN Setting </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="WAN Setting"
              v-model="id.Info.WANSetting"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> MAC Address </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="MAC Address"
              v-model="id.Info.MACAddress"
              required
              @focus="modal = false"
            />
          </b-col>
          <b-col cols="3"> Serial Number </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Serial Number"
              v-model="id.Info.SerialNumber"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3"> Gateway Type </b-col>
          <b-col cols="3">
            <b-form-input
              type="text"
              placeholder="Gateway Type"
              v-model="id.Info.GatewayType"
              required
              @focus="modal = false"
            />
          </b-col>
        </b-row>
      </section>
      <b-row v-if="this.DevicesToShow == true">
        <b-col>
          <b-button variant="outline-info" v-on:click="submitDevicesToDB()">
            Submit
          </b-button>

          <b-button variant="outline-info" v-on:click="resetForm()">
            Reset
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import { BIconX, BIconCheck } from "bootstrap-vue";
export default {
  components: {
    BIconX,
    BIconCheck,
  },
  methods: {
    submitDevicesToDB() {
      let LookUpURLnewOrderSubmit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersnewOrderSubmit = this.$apikeyPost;
      let LookUpRequestnewOrderSubmit = {
        RequestType: "Device",
        Action: "Insert",
        DataDict: [
          {
            Company: this.SelectedCompany,
            Devices: this.newOrderDeviceInfo,
          },
        ],
      };
      axios
        .post(
          LookUpURLnewOrderSubmit,
          LookUpRequestnewOrderSubmit,
          LookUpHeadersnewOrderSubmit
        )
        .then((response) => {
          response;
          alert("Devices Added");
          this.buttonCooldown = false;
          this.resetForm();
        });
    },

    addNewRowVersion(DeviceType, NoOfDevices) {
      NoOfDevices = Number(NoOfDevices);
      if ((DeviceType != "") & (NoOfDevices != "")) {
        if (DeviceType == "C-1") {
          for (let i = 0; i < NoOfDevices; i++) {
            this.newOrderDeviceInfo[0].C1.push({
              DeviceNo: this.newOrderDeviceInfo[0].C1.length + 1,
              DataValid: false,
              Info: {
                DeviceID: "",
                Double: "",
                Outdoor: "",
                MacAddress: "",
                Kernel: "",
                BoardVersion: "",
                LanguageVersion: "",
                OSversion: "",
              },
            });
          }
        }
        if (DeviceType == "O-1") {
          for (let i = 0; i < NoOfDevices; i++) {
            this.newOrderDeviceInfo[1].O1.push({
              DeviceNo: this.newOrderDeviceInfo[1].O1.length + 1,
              DataValid: false,
              Info: {
                DeviceID: "",
                DeviceName: "",
                HardwareVersion: "",
                DevEUI: "",
                AppEUI: "",
                AppKey: "",
                NetworkServerAddress: "",
              },
            });
          }
        }

        if (DeviceType == "HUB") {
          for (let i = 0; i < NoOfDevices; i++) {
            // this.newOrderDeviceInfo[2].HUB.push({
            //   DataValid: false,
            // });
            this.newOrderDeviceInfo[3].HUB.push({
              DeviceNo: this.newOrderDeviceInfo[3].HUB.length + 1,
              DataValid: false,
              Info: {
                GatewayName: "",
                GatewayType: "",
                GatewayID: "",
                GatewayEUI: "",
                GatewayUsername: "",
                GatewayPassword: "",
                SimCardNumber: "",
                FirmwareVersion: "",
                WANSetting: "",
                MACAddress: "",
                SerialNumber: "",
              },
            });
          }
        }

        // HUB
        this.DevicesToShow = true;
      }
    },

    removeRow(idxvalue) {
      this.newOrderDeviceInfo.splice(idxvalue, 1);
    },

    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },
    resetForm() {
      this.DivID = "";
      this.deactclURN = "";
      this.deactclFName = "";
      this.deactclLName = "";
      this.deactclDept = "";
      this.deactclLoc = "";
      this.fName = "";
      this.lName = "";
      this.clDept = "";
      this.clLocation = "";
      this.clEmail = "";
      this.DeviceRequestNo = "";
      this.messageforNewLocationEmail = "";
      this.DevicesToShow = false;
      this.SelectedCompany = "";
      this.DeviceType = "";
      this.newOrderDeviceInfo = [
        {
          C1: [],
        },
        {
          O1: [],
        },

        {
          WBU: [],
        },
        {
          HUB: [],
        },
      ];
    },

    submitNewOrder() {
      this.buttonCooldown = true;

      for (let y = 0; y < this.newOrderDeviceInfo.length; y++) {
        let NoToAdd = this.newOrderDeviceInfo[y].Quantity;
        this.orderTotalQuantity =
          Number(this.orderTotalQuantity) + Number(NoToAdd);
      }

      let LookUpURLnewOrderSubmit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersnewOrderSubmit = this.$apikeyPost;
      let LookUpRequestnewOrderSubmit = {
        RequestType: "Device",
        Action: "Order",
        DataDict: [
          {
            Company: this.newOrderCompany.id,
            EstFulfillmentDate: this.newOrderFulfillmentDate,
            OrderDate: this.newOrderDate,
            OrderID: this.newOrderID,
            OrderValue: this.newOrderValue,
            Total: this.orderTotalQuantity,
            DeviceCounts: this.newOrderDeviceInfo,
          },
        ],
      };
      axios
        .post(
          LookUpURLnewOrderSubmit,
          LookUpRequestnewOrderSubmit,
          LookUpHeadersnewOrderSubmit
        )
        .then((response) => {
          response;
          alert("Order Submitted");
          this.buttonCooldown = false;
        });
    },

    submitDeviceID(PiVersion, OrderID, Company) {
      this.buttonCooldown = true;

      let LookUpURLdeviceIDSubmit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersdeviceIDSubmit = this.$apikeyPost;
      let LookUpRequestdeviceIDSubmit = {
        RequestType: "Order",
        Action: "Assign",
        DataDict: [{ OrderID: OrderID, Company: Company, Devices: PiVersion }],
      };
      axios
        .post(
          LookUpURLdeviceIDSubmit,
          LookUpRequestdeviceIDSubmit,
          LookUpHeadersdeviceIDSubmit
        )
        .then((response) => {
          alert("Device ID's Assigned");
          response;
          this.buttonCooldown = false;
        });
    },

    submitDeviceOrderUpdate(data) {
      this.buttonCooldown = true;

      let LookUpURLDeviceOrderUpdate =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/superuser";
      let LookUpHeadersDeviceOrderUpdate = this.$apikeyPost;
      let LookUpRequestDeviceOrderUpdate = {
        RequestType: "Order",
        Action: "Update",
        DataDict: [
          {
            OrderID: data.OrderID,
            OrderDate: data.OrderDate,
            Company: data.Company,
            OrderQuantity: data.NoOfDevices,
            EstimatedFulfillmentDate: data.EstFulfillmentDate,
            OrderFulfilled: data.OrderFulfilled,
            ShippingDate: data.ShippingDate,
            OrderValue: data.Value,
          },
        ],
      };
      axios
        .post(
          LookUpURLDeviceOrderUpdate,
          LookUpRequestDeviceOrderUpdate,
          LookUpHeadersDeviceOrderUpdate
        )
        .then((response) => {
          alert("Order details updated");
          response;
          this.buttonCooldown = false;
        });
    },

    deviceSubmit() {
      this.buttonCooldown = true;

      let EmailHPAdd = {
        ToEmail: "support@seraphprotect.online",
        EmailText:
          "Hello, \\n\\nThe following Clarence Device has been requested.\\n\\n" +
          "Location:" +
          " " +
          this.contactLocation +
          "\\n\\nNumber Of Devices:" +
          " " +
          this.DeviceRequestNo +
          "\\n\\nUser Requesting:" +
          " " +
          this.userName +
          "\\n\\nSent from Seraph Protect",
        EmailSubject: "New Device Request ",
      };
      let EmailPosturl =
        "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/emailgateway";
      let EmailPostHeaders = this.$apikeyPost;
      axios
        .post(EmailPosturl, EmailHPAdd, EmailPostHeaders)
        .then((response) => {
          response;
          this.buttonCooldown = false;

          this.hideModal("DeviceRequest");
          this.resetForm();
          alert("Devices have been requested");
        })
        .catch((err) => {
          "Error: ===", err;
        });
    },

    HistorySubmit() {
      this.buttonCooldown = true;

      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };

      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
          this.buttonCooldown = false;
        });
    },
  },

  mounted() {
    let UserAccessGroup = this.$ProfilePortal;
    if (UserAccessGroup == null) {
      this.$router.push("/");
    }
    /* Company Lookup */
    // let LookUpUrlCompany =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersCompany = this.$apikeyPost;
    // this.LookUpRequest = { RequestType: "Company" };
    // axios
    //   .post(LookUpUrlCompany, this.LookUpRequest, LookUpHeadersCompany)
    //   .then((response) => {
    //     this.companylist = response.data.Values;
    //     for (let i = 0; i < this.companylist.length; i++) {
    //       var QuoteStr4 = this.companylist[i][0];
    //       this.companyArray.push({
    //         id: QuoteStr4,
    //         text: this.companylist[i][1],
    //       });
    //     }
    //   });

    let LookUpUrlExistingCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingCompany = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentChildCompanies",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingCompany,
        this.LookUpRequest,
        LookUpHeadersExistingCompany
      )
      .then((response) => {
        this.companyList = response.data.Values;

        for (let i = 0; i < this.companyList.length; i++) {
          this.companyArray.push({
            value: this.companyList[i][0],

            text: this.companyList[i][0],
          });
        }
      });

    /* Version Lookup */
    let LookUpUrlVersions =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersVersions = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "Version" };
    axios
      .post(LookUpUrlVersions, this.LookUpRequest, LookUpHeadersVersions)
      .then((response) => {
        this.versionlist = response.data.Values;
        for (let i = 0; i < this.versionlist.length; i++) {
          var QuoteStr4 = this.versionlist[i][0];
          this.versionArray.push({
            id: QuoteStr4,
            type: this.versionlist[i][1],
            sku: this.versionlist[i][2],
          });
        }
      });
    /* PiVersion */
    let LookUpUrlPiVersions =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersPiVersions = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PiVersion", RequestVariable: "" };
    axios
      .post(LookUpUrlPiVersions, this.LookUpRequest, LookUpHeadersPiVersions)
      .then((response) => {
        this.piVersionlist = response.data.Values;
        for (let i = 0; i < this.piVersionlist.length; i++) {
          var QuoteStr4 = this.piVersionlist[i][0];
          this.piVersionArray.push({
            id: QuoteStr4,
            Name: this.piVersionlist[i][1],
          });
        }
      });

    /* Old Look Ups */
  },

  data() {
    return {
      DevicesToShow: false,

      SelectedCompany: "",
      NoOfDevices: null,
      UserPortal: localStorage.getItem("profileportal"),
      ParentCompany: localStorage.getItem("ParentCompany"),
      companyArray: [],
      versionArray: [],
      piVersionArray: [],
      companylist: [],
      versionlist: [],
      piVersionlist: [],
      newOrderDeviceInfo: [
        {
          C1: [],
        },
        {
          O1: [],
        },

        {
          WBU: [],
        },
        {
          HUB: [],
        },
      ],
      DeviceType: "",
      DeviceTypeList: [
        { value: "C-1", text: "Clarence C-1" },
        { value: "O-1", text: "Clarence O-1" },
        { value: "HUB", text: "Network Gateway" },

        // { value: "WBU", text: "Washbasins" },
      ],
      fields: [
        {
          key: "OrderID",
          stickyColumn: true,
          isRowHeader: true,
          variant: "primary",
        },
        { key: "OrderDate" },
        { key: "Company" },
        { key: "NoOfDevices" },
        { key: "EstFulfillmentDate" },
        { key: "OrderFulfilled" },
        { key: "ShippingDate" },
        { key: "Value" },
        { key: "Assigned" },
        { key: "FurtherDetail" },
      ],
      openfields: [
        {
          key: "OrderID",
          stickyColumn: true,
          isRowHeader: true,
          variant: "primary",
        },
        { key: "OrderDate" },
        { key: "Company" },
        { key: "NoOfDevices" },
        { key: "EstFulfillmentDate" },
        { key: "OrderFulfilled" },
        { key: "ShippingDate" },
        { key: "Value" },
        { key: "Assigned" },
        { key: "UpdateOrder" },
      ],
      openOrderSubmitData: [],
      closedOrderArray: [],
      buttonCooldown: false,
      OrderFields: ["Order "],
    };
  },

  watch: {
    location() {
      this.filterLocations();
    },
    buttonCooldown() {
      this.btnCooldown();
    },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 75%;
  padding: 5px 5px 5px 5px;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
}
.form-control {
  width: 75%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 50%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 50%;
}

div.tab {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
}

.tablinksClientAdmin {
  width: 50%;
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
}

/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 33.3%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 33.3%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 33.3%;
}

.reportTabActive {
  width: 33.3%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}

/*Open Orders */

.openOrderContainer {
  border-radius: 25px;
  background-color: #eeeeee;
  width: 100%;
}

.openOrderIDTitle {
  font-size: 0.9rem;
  font-weight: 600;
  text-align: left;
  padding-left: 10px;
}

.deviceDetails {
  background-color: rgba(255, 255, 255, 0);
  text-align: center;
  width: 100%;
  border: solid 1px rgba(180, 180, 180, 0);
}
.headerText {
  font-weight: 400;
}

.dataText {
  font-weight: 600;
}

.deviceOpenOrderInfo {
  width: 100%;
  padding: none;
  margin: none;
}

.deviceOpenOrderInfoData {
  width: 20%;
  padding: 0 !important;
  margin: none;
  border-bottom: solid 1px rgb(180, 180, 180);
}
.deviceOpenOrderInfoDataLine2 {
  width: 25%;
  padding: 0 !important;
  margin: none;
}
.deviceOpenOrderInfoDataLine3 {
  width: 33%;
  padding: 0 !important;
  margin: none;
}

.deviceClosedOrderInfoData {
  width: 50%;
  padding: 0 !important;
  margin: none;
}

.deviceClosedOrderInfo {
  text-align: center;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 0px;
  margin: none;
  border-top: solid 1px rgb(180, 180, 180);
}

.versionInputBox {
  border: solid 1px rgb(230, 230, 230);
  padding: 2rem;
  margin: auto 0;
  width: 100%;
  align-items: center;
}
.orderInputTitle {
  text-align: center;
  padding: 0;
}
.orderInputTitle p {
  margin-bottom: 0 !important;
}

.submitOrderButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 25px;
  background-color: #343a40;
}

#Selector {
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.OrderDetails {
  padding: 1px;
  margin: none;
}
</style>
